export default __webpack_public_path__ + "static/media/snowuns-logo.3cbc0b4f.webp";